<template>
  <div>
    <Banner type="part" />
    <div class="page-container j-container-box-shadow container">
      <div class="title">
        <div class="j-title">{{ $t('part_result.title') }}</div>
        <template v-if="hasModel">
          <a-divider type="vertical" style="margin: 0 40px; height: 30px;" />
          <div class="j-content">
            <span class="model-label">
              {{ $t('part_result.model_label') }} :
            </span>
            <span>{{ model || '' }}</span>
          </div>
        </template>
      </div>

      <a-divider style="margin: 30px 0 0 0;" />

      <span class="j-content sub-title">{{ $t('part_result.part_list') }}</span>

      <a-spin v-if="hasResult" :spinning="loading">
        <div class="part-container">
          <a-row :gutter="[40, 40]">
            <a-col :xs="24" :md="6" v-for="item in parts" :key="item.id">
              <PartResultItem
                :item="item"
                :partName="partName"
                :modelNum="modelNum"
              />
            </a-col>
          </a-row>
        </div>
      </a-spin>

      <div class="no-result" v-if="!hasResult">
        <img
          alt="no-data"
          src="@/assets/images/noData.png"
          width="164"
          height="141"
        />
        <span class="no-data-msg j-content">
          {{ $t('part_result.no_product_found') }}
        </span>

        <span class="try-again j-weak">{{ $t('part_result.try_again') }}</span>
      </div>

      <div class="pagination-container">
        <a-pagination
          v-model:current="pageNo"
          :page-size-options="pageSizeOptions"
          :total="total"
          show-size-changer
          v-model:pageSize="pageSize"
          @showSizeChange="onShowSizeChange"
          @change="onChange"
          show-quick-jumper
        >
          <template #buildOptionText="props">
            <span>{{ props.value }} {{ $t('common.page_per_item_text') }}</span>
          </template>
        </a-pagination>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import PartResultItem from './PartResultItem.vue';
import { getPartPartsList } from '@/api/apis';
import Banner from '@/components/banner/Banner.vue';

export default defineComponent({
  name: 'PartResult',
  data() {
    return {
      loading: false,
      parts: [],
      pageNo: 1,
      pageSize: 8,
      pageSizeOptions: ['8', '16', '24'],
      current: 1,
      total: 0,
      hasResult: true,
      hasModel: false,
      // query
      modelNum: '',
      model: '',
      partName: '',
      vehicleId: ''
    };
  },
  components: {
    PartResultItem,
    Banner
  },
  created() {
    const route = useRoute();

    const query = route.query || {};

    this.hasModel = Number(query.isNo) === 0;

    this.model = query.model as string;

    this.hasResult = Number(query.hasResult) === 1;

    this.vehicleId = query.vehicleId as string;
    if (this.hasModel) {
      if (this.hasResult) {
        this.partName = query.partName as string;

        this.loadData();
      }
    } else {
      if (this.hasResult) {
        this.modelNum = query.modelNum as string;

        this.loadData();
      }
    }
  },
  methods: {
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;

      const params: any = {
        modelNum: this.modelNum,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        partName: this.partName
      };

      // if (this.hasModel) {
      //   params.vehicleId = +this.vehicleId;
      // }
      params.vehicleId = +this.vehicleId || undefined;

      const res = await getPartPartsList(params);

      if (res.success) {
        const data = res.result || {};

        this.parts = data.records || [];

        this.total = data.total;

        this.hasResult = this.total > 0;
      }

      this.loading = false;
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 49px;
  background-color: white;

  .title {
    padding: 32px 0 0 0;
    display: flex;
    align-items: center;
    color: $primary-color;
  }

  .sub-title {
    padding: 30px 0;
    display: block;
  }

  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid #d9d9d9;

    padding: 160px 0;

    .no-data-msg {
      padding: 20px 0 10px 0;
    }

    .try-again {
      color: #999999;
    }
  }

  .pagination-container {
    padding: 38px 0 40px 0;
    text-align: right;
  }
}
</style>
